export const phoneMask = (phone) => {
  const separatePhone = phone
    .toString()
    .replace(/\D/g, '')
    .match(/(\d{3})(\d{3})(\d{4})/);
  return `(${separatePhone[1]}) ${separatePhone[2]} ${separatePhone[3]}`;
};
